const base_url = window.api_host;
// const base_url = 'https://beta-dot-craver-app.appspot.com/api/';

export default class ResourcesAPI {
  static loginAdmin = (admin) => {
    const path = `${base_url}admins/login`;
    const request = (
      new Request(path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(admin),
      })
    );
    return handleResponse({ request });
  }

  static addResource = (apiToken, resource, resourcePath, isPlain) => {
    const path = base_url + generatePath(resourcePath);
    const request = (
      new Request(path, {
        method: 'POST',
        headers: generateHeader(apiToken),
        body: JSON.stringify(resource),
      })
    );
    return handleResponse({ request, isPlain, resourcePath });
  }

  static duplicateResource = (apiToken, resourcePath, isPlain) => {
    const path = base_url + generatePath(resourcePath);
    const request = (
      new Request(path, {
        method: 'put',
        headers: generateHeader(apiToken),
      })
    );
    return handleResponse({ request, isPlain, resourcePath });
  }

  static deleteResource = (apiToken, resourcePath) => {
    const path = base_url + generatePath(resourcePath);
    const request = (
      new Request(path, {
        method: 'DELETE',
        headers: generateHeader(apiToken),
      })
    );
    return handleResponse({ request, resourcePath, isPlain: true });
  }

  static updateResource = (apiToken, resource, resourcePath) => {
    const path = base_url + generatePath(resourcePath);
    const request = (
      new Request(path, {
        method: 'PUT',
        headers: generateHeader(apiToken),
        body: JSON.stringify(resource),
      })
    );
    return handleResponse({ request, resourcePath });
  }

  static getAllResources = (apiToken, resourcePath) => {
    const isPlain = resourcePath[resourcePath.length - 1] === true;
    if (isPlain) {
      resourcePath.splice(resourcePath.length - 1, 1);
    }
    const path = base_url + generatePath(resourcePath);
    const request = (
      new Request(path, {
        method: 'GET',
        headers: generateHeader(apiToken),
      })
    );
    return handleResponse({ request, isPlain, resourcePath });
  }

  static getResource = (apiToken, resourcePath) => {
    const path = base_url + generatePath(resourcePath);
    const request = (
      new Request(path, {
        method: 'GET',
        headers: generateHeader(apiToken),
      })
    );
    return handleResponse({ request, resourcePath });
  }

  static downloadResource = (apiToken, resourcePath) => {
    const path = base_url + generatePath(resourcePath);
    const request = (
      new Request(path, {
        method: 'GET',
        headers: generateHeader(apiToken),
      })
    );
    return handleDownloadResponse(request);
  }

  static uploadResource = (apiToken, resource, resourcePath) => {
    const path = base_url + generatePath(resourcePath);
    const request = (
      new Request(path, {
        method: 'POST',
        headers: generateHeader(apiToken),
        body: JSON.stringify(resource),
      })
    );
    return handleResponse({ request, resourcePath });
  }

  static reprint(user, resourcePath, adminToken) {
    const path = base_url + generatePath(resourcePath);
    const request = (
      new Request(path, {
        method: 'POST',
        headers: generateHeader(adminToken),
      })
    );
    return handleResponse({ request });
  }
}

export const handleResponse = ({ request, isPlain, resourcePath }) => fetch(request)
  .then((response) => {
    if (response.status == 204) {
      return (response.text()).then(data => ({ data, response }));
    }

    try {
      return (!isPlain ? response.json() : response.text()).then(data => ({ data, response }));
    } catch (e) {
      console.error(e);
      Sentry.captureException(e);
      return (!isPlain ? { message: '' } : '').then(data => ({ data, response }));
    }
  })
  .then(({ data, response }) => {
    if (!response.ok) {
      return Promise.reject(!isPlain ? data.message : data);
    }
    const body = {
      data,
      token: response.headers.get('api_token'),
      resourcePath,
    };
    return Promise.resolve(body);
  }).catch((error) => {
    console.log(error);
    if (error == 'TypeError: Failed to fetch') { error = 'Server is not responding'; }
    return Promise.reject(error);
  });

export const handleDownloadResponse = (request, isPlain) => fetch(request)
  .then(response => (response.blob()).then(data => ({ data, response })))
  .then(({ data, response }) => {
    if (!response.ok) {
      return Promise.reject(!isPlain ? data.message : data);
    }
    const headerContentDisposition = response.headers.get('Content-Disposition');
    const fileName = headerContentDisposition ? headerContentDisposition.split('filename="')[1].replace('"', '') : 'file';
    const url = window.URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    link.click();
    return Promise.resolve({});
  }).catch((error) => {
    console.log(error);
    if (error == 'TypeError: Failed to fetch') {
      error = 'Server is not responding';
    }
    return Promise.reject(error);
  });


export function generatePath(resourcePath) {
  return resourcePath.join('/');
}

export function generateHeader(token) {
  const apiHeader = {};
  apiHeader.Authorization = `Bearer ${token}`;
  apiHeader['Content-Type'] = 'application/json';
  return apiHeader;
}
